<template>
  <div id="submissions-page">
    <div class="flex-grow my-4">
      <h1>{{ $t('Contacts') }}</h1>
    </div>

    <div class="vx-card full-page">
      <grid-panel
        :column-defs="columnDefs"
        :url="url"
        :apiParams="apiParams"
        :loadOnRender="false"
        :gridOptions="gridOptions"
        @download="download"
      >

        <template slot="right">
          <date-range-picker @update:startDate="startDate = $event" @update:endDate="endDate = $event" />
        </template>

      </grid-panel>
    </div>
  </div>
</template>

<script>
import GridPanel from '@/views/components/ag-grid/GridPanel';
import GridActionsMenu from "../../components/extra-components/GridActionsMenu";
import SubmissionsConfig from '@/grids/Submissions/SubmissionsConfig';
import DateRangePicker from "../../components/calendar/DateRangePicker";
import CellRendererDate from "../../components/ag-grid/cell-renderer/CellRendererDate";
import CellRendererDownload from "../../components/ag-grid/cell-renderer/CellRendererDownload";
import CellRendererCurrency from "../../components/ag-grid/cell-renderer/CellRendererCurrency";
import FileDownloadMixin from "../../../components/mixins/FileDownloadMixin";
import moment from 'moment';

export default {
  components: {
    GridPanel,
    GridActionsMenu,
    DateRangePicker,
    CellRendererDate,
    CellRendererDownload,
    CellRendererCurrency,
  },
  mixins: [FileDownloadMixin],
  computed: {
    apiParams() {
      // Only set these when we have the full date range available
      // Otherwise it loads the endpoint twice and fails the first time due to missing parameters
      if (!this.startDate || !this.endDate) {
        return null;
      }

      return {
        startDate: (this.startDate) ? moment(this.startDate).format('YYYY-MM-DD') : null,
        endDate: (this.endDate) ? moment(this.endDate).format('YYYY-MM-DD') : null
      }
    }
  },
  data() {
    return {
      columnDefs: SubmissionsConfig,
      url: (params) => this.$api.submissions.list(params),
      startDate: null,
      endDate: null,
      gridOptions: {}
    };
  },
};
</script>
